import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { parseISO } from 'date-fns';
import { SeasonalRule } from 'models/seasonality/SeasonalRule';
import { formatRangeMediumWithCurrentYearCheck } from 'utils/dateTimeUtils';

const DateCell = ({ row }: { row: Row<SeasonalRule> }) => {
  const { t } = useTranslation();
  const { startDate, endDate } = row.original;

  const { fromFormatted, toFormatted } = formatRangeMediumWithCurrentYearCheck({
    from: parseISO(startDate),
    to: parseISO(endDate),
    t,
  });

  return <span>{`${fromFormatted} - ${toFormatted}`}</span>;
};

export default DateCell;
